import React from "react";
import Anime from 'react-anime';
import arrowImg from '../assets/elements/Scroll-Nav-Arrow.svg';
import blueArrowImg from '../assets/elements/blue-arrow.svg';
import './ScrollDown.scss';
export default ({ text, isWhite, onClickNextSlide }) => {
  const scrollEncourage = {
    translateY: [
      { value: 0, duration: 0, easing: 'easeOutSine'},
      { value: 30, duration: 2500, easing: 'easeInSine'}
    ],
    loop: true,
    direction: 'alternate',
  }

  return (
    <div className={`scroll-down ${isWhite === true ? 'white' : ''}`}  onClick={() => onClickNextSlide()}>
      <span>{text}</span>
      <div className="scroll-down-box">
        <Anime {...scrollEncourage}>
          {isWhite === true ? <img src={arrowImg} alt="scroll down"/> : <img src={blueArrowImg} alt="scroll down"/>}
        </Anime>
      </div>
    </div>
  );
};
